import React from "react";

interface RadioButtonProps extends React.HTMLAttributes<HTMLInputElement>{
  checked?: boolean | undefined
  value?: string | number 
}

class RadioButton extends React.Component<RadioButtonProps> {
  
  render() {
    return (     
      <input
        {...this.props}
        type="radio"  
        style={{
          width:"18px",
          height:"18px",
        }}        
      />
    );
  }
}

export default RadioButton;